import React from 'react';
import { Confirmation } from 'components/common';
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import PropTypes from 'prop-types';
import { recalculatePeriod } from "redux/crm/shipment/orderIntakeSlice";
const ReCalculatePeriodConfirm = ({ open, setOpen, period }) => {
  const dispatch = useDispatch();

  const handleConfirm = () => {
    try {
      dispatch(recalculatePeriod(period));
      setOpen(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Confirmation
      show={open}
      title="Recalculate period confirmation"
      message={<>Are you sure you want to recalculate the period <strong>{period}</strong>?</>}
      type="warning"
      confirmText="Yes, recalculate"
      cancelText="Cancel"
      onConfirm={handleConfirm}
      onCancel={() => setOpen(false)}
    />
  );
};

ReCalculatePeriodConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  period: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default ReCalculatePeriodConfirm;
